import { insights, type Insight } from './content/insights';

type InsightsPageProps = {
  onOpenArticle: (slug: string) => void;
  onAssessment: () => void;
};

export function InsightsPage({ onOpenArticle, onAssessment }: InsightsPageProps) {
  const [featured, ...more] = insights;
  return (
    <main className="insights-page">
      <section className="insights-hero">
        <img src="/assets/page08-first-hour.jpg" alt="Dark ocean water opening toward a blue horizon" />
        <div className="insights-hero-grade" aria-hidden="true" />
        <div className="insights-hero-copy">
          <span>IMTHEHOUSE / INSIGHTS</span>
          <h1>THE THINKING<br />BEHIND COMMAND.</h1>
          <p>Essays on attention, risk, engineered behavior, and what it takes to put your own engine back on your side.</p>
        </div>
      </section>

      <section className="insights-featured" aria-labelledby="featured-insight-heading">
        <button className="insights-featured-image" type="button" onClick={() => onOpenArticle(featured.slug)} aria-label={`Read ${featured.title}`}>
          <img src={featured.image} alt={featured.imageAlt} />
        </button>
        <article>
          <span>{featured.number} / {featured.category}</span>
          <h2 id="featured-insight-heading">{featured.title}</h2>
          <p>{featured.excerpt}</p>
          <button className="insights-read" type="button" onClick={() => onOpenArticle(featured.slug)}>READ THE ESSAY <span aria-hidden="true">→</span></button>
        </article>
      </section>

      <section className="insights-list" aria-label="Latest insights">
        <header><span>LATEST</span><p>Long-form thinking for men who would rather understand the machine than keep negotiating with it.</p></header>
        <div>
          {more.map((insight) => <InsightCard key={insight.slug} insight={insight} onOpen={() => onOpenArticle(insight.slug)} />)}
        </div>
      </section>

      <section className="insights-assessment">
        <span>THE POINT ISN’T MORE INFORMATION.</span>
        <h2>IT’S COMMAND.</h2>
        <p>If the sportsbook still has the edge, start with one private conversation.</p>
        <button className="site-button site-button-primary" type="button" onClick={onAssessment}>BEGIN THE PRIVATE ASSESSMENT</button>
      </section>

      <SiteFooter />
    </main>
  );
}

function InsightCard({ insight, onOpen }: { insight: Insight; onOpen: () => void }) {
  return (
    <article className="insight-card">
      <button type="button" onClick={onOpen} aria-label={`Read ${insight.title}`}><img src={insight.image} alt={insight.imageAlt} /></button>
      <div>
        <span>{insight.number} / {insight.category}</span>
        <h2>{insight.title}</h2>
        <p>{insight.excerpt}</p>
        <button className="insights-read" type="button" onClick={onOpen}>READ · {insight.readTime} <span aria-hidden="true">→</span></button>
      </div>
    </article>
  );
}

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div><strong>IMTHEHOUSE</strong><span>Private performance coaching.</span></div>
      <p>IMTHEHOUSE is a nonclinical performance and coaching program—not therapy, medical treatment, or crisis care. If you’re in crisis, call or text 988. Gambling-specific support: 1-800-GAMBLER.</p>
    </footer>
  );
}
